import { Controller } from "react-hook-form";

import DefaultSelect from "./DefaultSelect";

const ExtendedDefaultSelect = ({
  control,
  name,
  options,
  placeholder,
  valueExtended = null,
  customSelectStyle,
}) => {
  return (
    <Controller
      {...{ control, name }}
      render={({ field: { onChange, value } }) => (
        <DefaultSelect
          {...{
            id: name,
            options,
            onChange,
            value: valueExtended !== null ? valueExtended : value,
            placeholder,
            customSelectStyle,
          }}
        />
      )}
    />
  );
};

export default ExtendedDefaultSelect;
